import { useState } from 'react'

// import { postData, postFormData } from 'react-router-dom'

import { postFormData, postData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'
import { useSnackbarManager } from '../../components/common/snackbar'
// import { parseQueryParams } from '../../store/authStore'
// import { parseQueryParams } from './schema'
import { parseQueryParams } from '../../utilities/parsers'

export const login = (input: any, params: any, loginUrl: string) =>
  postFormData(`${loginUrl}${parseQueryParams(params)}`, input)
export const useLogin = (handleOnSuccess: (data: any) => any) => {
  // const { userData } = useAuthStore()
  const { enqueueSnackbar } = useSnackbarManager()
  // const navigate = useNavigate()
  const [isLoading, setIsLoading] = useState(false)
  const mutate = async (input: any, params: any, isBackoffice: boolean) => {
    // , from: any
    setIsLoading(true)

    try {
      const loginUrl = isBackoffice ? apiUrl?.LOGIN_URL : apiUrl?.USER_LOGIN_URL
      // const loginUrl = apiUrl?.USER_LOGIN_URL
      const res = await login(input, params, loginUrl)

      // let otp_enable = false
      // if (res?.data?.detail == 'totp enabled') {
      //   otp_enable = true
      // } else {
      //   if (res?.data) {

      //   }
      // }
      handleOnSuccess(res?.data)
      setIsLoading(false)
      // navigate('/dashboard')
    } catch (err: any) {
      // Handle errors explicitly
      enqueueSnackbar(
        err?.response?.data?.error?.message ??
          err?.response?.data?.detail ??
          'Login failed',
        { variant: 'error' }
      )
      setIsLoading(false)
    }
  }

  return { mutate, isLoading }
}

// Utility functions for password-related actions
export const resetPassword = (email: any) =>
  postData(`password-recovery/${email}`, {})
export const ForgetResetPassword = (data: any) =>
  postData('reset-password/', data)
export const verifyResetPassword = (data: any) =>
  postData('forgot-password-verify-token', data)
export const forceChangePassword = (data: any) =>
  postData('employee/force-change-password/', data)

export const update2fa = (id: string, data: any) =>
  postData(`/update/${id}/2fa/`, data)
